// Module
var code = "<c-contrast-button>\n    <button class=\"c-contrast\"><i class=\"contrast__icon fas fa-adjust\"></i> Contrast</button>\n</c-contrast-button>";
// Exports
export default code;